import { render, staticRenderFns } from "./choseCourseSchoolBase.vue?vue&type=template&id=f5ef18c8&scoped=true&"
import script from "./choseCourseSchoolBase.vue?vue&type=script&lang=js&"
export * from "./choseCourseSchoolBase.vue?vue&type=script&lang=js&"
import style0 from "./choseCourseSchoolBase.vue?vue&type=style&index=0&id=f5ef18c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ef18c8",
  null
  
)

export default component.exports